import React, { useEffect, useState } from 'react';
import { UserSummaryType } from '../../../../../../../api/types/user/user-summary.type';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import globalProgramStore from '../../../../../../../stores/program-store';
import { Chip } from 'primereact/chip';
import CancelButton from '../../../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../../../component/ui/buttons/approve-button/approve-buttons';
import { addNewStudentsOperation } from '../../../../operations/add-new-students-operation';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import { CourseMetadataType } from '../../../../../../../api/types/programs/course/course-metadata.type';
import { PhoneNumberComponent } from '../../../../../../../utils/international-to-israeli';

interface AddNewStudentsFromProgramModel {
  courseMetadata?: CourseMetadataType;
  closeDialog: () => void;
}

const AddNewStudentsFromProgram: React.FC<AddNewStudentsFromProgramModel> = ({
  courseMetadata,
  closeDialog,
}) => {
  const [users, setUsers] = useState<UserSummaryType[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<UserSummaryType[]>([]);
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    const currentId = globalProgramStore.getCurrentId() ?? 1;
    const currentProgram = globalProgramStore.programs.get(currentId);

    if (
      currentProgram &&
      courseMetadata !== undefined &&
      courseMetadata.programYear !== undefined
    ) {
      const details = currentProgram.details?.years[courseMetadata.programYear];

      if (details && details.students) {
        setUsers(details.students);
      } else {
        setUsers([]);
      }
    } else {
      // If courseMetadata or programYear is missing, show no students instead of all
      setUsers([]);
    }
  }, [globalProgramStore.currentId, courseMetadata]);

  const handleApprove = async () => {
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.details?.id;
    const selectedUserIds = selectedUsers.map((userItem) => userItem.id);
    await addNewStudentsOperation(
      programId,
      courseId,
      selectedUserIds,
      selectedUsers,
      setLoading,
      closeDialog,
    );
  };
  return (
    <div>
      <DataTable
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={users}
        selection={selectedUsers}
        onSelectionChange={(e) => {
          setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          marginTop: '16px',
        }}
      >
        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
        <Column
          style={{ textAlign: 'right', width: '3rem' }}
          field="firstName"
          header="שם"
        />
        <Column field="lastName" header="" style={{ textAlign: 'right' }} />
        <Column
          field="nationalId"
          header="ת.ז"
          style={{ textAlign: 'right' }}
        />
        <Column
          field="phoneNumber"
          header="טלפון נייד"
          style={{ textAlign: 'right' }}
          body={(rowData: UserSummaryType) => (
            <PhoneNumberComponent phoneNumber={rowData.phoneNumber} />
          )}
        />
        <Column
          field="dateOfBirth1"
          header="תאריך לידה"
          style={{ textAlign: 'right' }}
          body={(rowData: UserSummaryType) =>
            rowData.dateOfBirth
              ? new Date(rowData.dateOfBirth).toLocaleDateString('he-IL') // Format date to 'dd/mm/yyyy' for Hebrew locale
              : ''
          }
        />
      </DataTable>

      <div style={{ marginTop: '16px' }} />
      {selectedUsers &&
        selectedUsers.map((userItem, index) => (
          <Chip
            key={userItem.id} // Adding a key for each Chip
            label={`${userItem.firstName} ${userItem.lastName}`}
            removable={true}
            onRemove={() => {
              console.log('');
            }}
            style={{ marginLeft: '8px', marginTop: '8px' }}
          />
        ))}

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          marginTop: '20px',
          paddingBottom: '10px',
        }}
      >
        <CancelButton
          onClick={() => {
            closeDialog();
          }}
        />

        <div style={{ width: '10px' }} />
        <ApproveButtons
          isLoading={false}
          onClick={async () => {
            await handleApprove();
          }}
        />
      </div>
    </div>
  );
};

export default AddNewStudentsFromProgram;
